import { Avatar } from '@crehana/compass.ui/v3/avatar';

import type { TRequestPerson } from '../../../types';

type TRequesterBannerProps = {
  user: TRequestPerson;
};

export const RequesterBanner = ({ user }: TRequesterBannerProps) => (
  <div className="tw-flex tw-items-center tw-cds-gap-3 tw-cds-bg-subtle-01 tw-border-b tw-border-solid tw-cds-border-divider tw-cds-p-5">
    <Avatar src={user.profile_picture.url} alt={user.full_name} size="md" />
    <div className="tw-flex tw-flex-col">
      <span className="tw-cds-font-subtitle-02 tw-cds-text-primary">
        {user.full_name}
      </span>
      <span className="tw-cds-font-body-02 tw-cds-text-secondary">
        {user.position?.position_name ?? ''}
      </span>
    </div>
  </div>
);
